import { render } from "./AlarmView.vue?vue&type=template&id=2b68fea0"
import script from "./AlarmView.vue?vue&type=script&lang=js"
export * from "./AlarmView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__